{
    "userCalendarTitle": "Votre agenda",
    "userCalendarIsLoading": "Chargement de votre agenda...",
    "userCalendarIsEmpty": "Votre agenda est vide!"
  }
  